import * as filterValidations from './filterValidations';

export default {
  filterValidations,
};
